export default "__VITE_ASSET__D6gF8EPS__"